import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import FileSaver from 'file-saver'
import moment from 'moment'

import {
  fetchCollection,
  baseRequest
} from './index'

import { areaActivitySchema } from '../schemas'

export const AREA_ACTIVITIES_REQUEST = 'AREA_ACTIVITIES_REQUEST'
export const AREA_ACTIVITIES_SUCCESS = 'AREA_ACTIVITIES_SUCCESS'
export const AREA_ACTIVITIES_FAILURE = 'AREA_ACTIVITIES_FAILURE'

function fetchActivitiesForArea (url, areaId, isNewPage) {
  return fetchCollection({
    url,
    key: 'areaActivities',
    schema: areaActivitySchema,
    actions: [ AREA_ACTIVITIES_REQUEST, AREA_ACTIVITIES_SUCCESS, AREA_ACTIVITIES_FAILURE ],
    responseInterceptor: response => ({ ...response, areaId, isNewPage })
  })
}

export const DOWNLOAD_AREA_ACTIVITIES_HISTORY_REQUEST = 'DOWNLOAD_AREA_ACTIVITIES_HISTORY_REQUEST'
export const DOWNLOAD_AREA_ACTIVITIES_HISTORY_SUCCESS = 'DOWNLOAD_AREA_ACTIVITIES_HISTORY_SUCCESS'
export const DOWNLOAD_AREA_ACTIVITIES_HISTORY_FAILURE = 'DOWNLOAD_AREA_ACTIVITIES_HISTORY_FAILURE'

export function downloadCSV (areaId, area = null) {
  return baseRequest({
    url: `/areas/${areaId}/activity`,
    method: 'GET',
    actions: [ DOWNLOAD_AREA_ACTIVITIES_HISTORY_REQUEST, DOWNLOAD_AREA_ACTIVITIES_HISTORY_SUCCESS, DOWNLOAD_AREA_ACTIVITIES_HISTORY_FAILURE ],
    responseInterceptor: (data, response) => {
      let responseData = data.area_activities.map((areaActivity) => {
        return [
          (areaActivity.activity.technician) ? areaActivity.activity.technician.name : '',
          areaActivity.activity.approval_status,
          areaActivity.activity.status,
          (areaActivity.activity.services) ? areaActivity.activity.services.join(';') : '',
          areaActivity.activity.completed_at ? moment.utc(areaActivity.activity.completed_at).format('ddd MMM DD YYYY HH:mm:ss (z)') : '',
          (areaActivity.activity_type === 'Comment' && areaActivity.activity.user) ? areaActivity.activity.user.name : '',
          (areaActivity.activity_type === 'Comment') ? areaActivity.activity.body.replace(/[\n\r]/g, ' ') : '',
          (areaActivity.activity_type === 'Comment' && areaActivity.activity.created_at) ? moment.utc(areaActivity.activity.created_at).format('ddd MMM DD YYYY HH:mm:ss (z)') : ''].join(',')
      })

      responseData.unshift([
        'Technician Name',
        'Approval Status',
        'Status',
        'Services',
        'Completed At',
        'Commented By',
        'Comment',
        'Commented At'
      ].join(','))

      if (!isEmpty(area)) {
        responseData.unshift(`,,,,,,,`)
        responseData.unshift(`Area Name: ${area.name},,,,,,,`)
      }

      responseData = responseData.join("\r\n")
      let file = new File([responseData], `area_activity_history-${areaId}.csv`, { type: "text/csv" })

      FileSaver.saveAs(file)
    }
  })
}

export function loadActivitiesForArea (areaId, nextPage, reload) {
  const firstPageUrl = `/areas/${areaId}/activity`

  return (dispatch, getState) => {
    let {
      nextPageUrl = firstPageUrl,
      pageCount = 0
    } = get(getState(), `pagination.activitiesByArea.${areaId}`, {})

    if (reload) {
      nextPageUrl = firstPageUrl
    }

    if (pageCount > 0 && !nextPage && !reload) {
      return null
    }

    return dispatch(fetchActivitiesForArea(nextPageUrl, areaId, nextPage))
  }
}



// WEBPACK FOOTER //
// ./src/actions/area-activities.js